import { Grid } from '@mui/material';
import * as React from 'react';
import { ICategoryType } from '../../../all-types';
import { CategoryCard } from '../components';


interface ICategoryPanelProps {
    setCategoryTxt: (txt: string) => void;
    categories: ICategoryType[]
}

const CategoryPanel: React.FC<ICategoryPanelProps> = ({ setCategoryTxt, categories: categoryList }) => {
    const ALL_NAME = "ALL";
    const [selectedCategory, setSelectedCategory] = React.useState(ALL_NAME);

    const handleCategorySelect = (txt: string) => {
        setSelectedCategory(txt);
        if (txt === ALL_NAME) {
            setCategoryTxt("");
        } else {
            setCategoryTxt(txt);
        }
    }

    React.useEffect(() => {
        setCategoryTxt("");
    }, [])

    const ALLICON = "https://firebasestorage.googleapis.com/v0/b/lightworks-tech.appspot.com/o/ruchi-vedika%2Fprops%2Fall-categories-icon.png?alt=media&token=d4380e93-6d2b-4771-9e08-83eb4e60b93d";

    return (
        <Grid container>
            <Grid item xs={12} key={"all-category"}>
                <CategoryCard category={{ categoryId: "763573", categoryName: ALL_NAME, categoryIcon: ALLICON }}
                    selectedCategory={selectedCategory}
                    onClick={() => handleCategorySelect(ALL_NAME)} />
            </Grid>
            {categoryList?.map((c) => (
                <Grid item xs={12} key={c.categoryId}>
                    <CategoryCard category={c}
                        selectedCategory={selectedCategory}
                        onClick={() => handleCategorySelect(c.categoryName)} />
                </Grid>
            ))}
        </Grid>
    );
};

export { CategoryPanel };

